import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { title, content, image, price, features } = plan;

  return (
    <div className="plan-item">
      <h3>{title}</h3> {/* Plan Title */}
      <p>{content}</p> {/* Plan Description */}
      <div className='price'>
        <img src={image} alt={title} /> {/* Plan Image */}
        <span>${price}</span> {/* Plan Price */}
      </div>
      {/* List of Features */}
      <ul>
        {features.map((feature, index) => (
          <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
        ))}
      </ul>
      <Button link={"Contact-us"} title={"order now"} />
    </div>
  );
};

export default Plan;